// src/components/FloatingButtons.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

const FloatingButtons = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        display: "flex",
        flexDirection: "column",
        gap: "12px", // space between buttons
        zIndex: 1000,
      }}
    >
      {/* New Button for IIITH Prep */}
      {/* <button
        onClick={() => navigate("/iiithprep#iiith_prep_top")}
        style={{
          background: "#fff",
          color: "#30b0c7",
          border: "none",
          padding: "12px 18px",
          borderRadius: "30px",
          cursor: "pointer",
          fontWeight: "bold",
          boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
        }}
      >
        LEEE & PGEE IIITH_Prep is live 🚀
      </button> */}

      {/* Existing Star Student Button */}
      <button
        onClick={() => navigate("/aboutus#our-star-student")}
        style={{
          background: "#30b0c7",
          color: "white",
          border: "none",
          padding: "12px 18px",
          borderRadius: "30px",
          cursor: "pointer",
          fontWeight: "bold",
          boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
        }}
      >
        ⭐ Meet our Star Student
      </button>
    </div>
  );
};

export default FloatingButtons;
